<div
  class="w-full px-[1rem] md:px-[2.5rem] py-[1.5rem] flex flex-col md:gap-2 items-center rounded-lg card mb-4 md:mb-6"
>
  <span class="text-[#2C3035] text-[2rem] font-bold">{{ availableGanas() }}</span>
  <span class="text-[#007DCB] text-[1rem]">{{ 'rewards.availableGanas' | translate }}</span>
</div>
@if (redemptionsPaused()) {
  <app-alert
    data-testid="redemptions-paused-notice"
    type="warning"
    localizableText="rewards.redemptionsPaused"
    [closable]="false"
    class="block mb-4 md:mb-6"
  />
}
@if (showPromotionsBanner()) {
  <a
    data-testid="need-ganas-banner"
    routerLink="/workspace/promotions"
    class="need-ganas-banner w-full px-[1.25rem] py-[1.25rem] md:px-[1.5rem] md:py-[1.5rem] flex items-center justify-center gap-[0.5rem] md:gap-[1.5rem] rounded-lg mb-4 md:mb-6 relative overflow-hidden cursor-pointer no-underline"
  >
    <img
      src="../../../../assets/img/rewards/need-ganas-banner-bg.png"
      alt=""
      class="absolute inset-0 w-full h-full object-cover rounded-lg pointer-events-none"
    />
    <div class="flex flex-col items-center relative z-10">
      <span class="text-[#115C61] text-[1rem] md:text-[1.375rem] font-bold leading-[1.6]">{{
        'rewards.needGanas' | translate
      }}</span>
      <span class="text-[#115C61] text-[0.8125rem] md:text-[0.9375rem] font-normal leading-[1.6]">{{
        'rewards.explorePromotions' | translate
      }}</span>
    </div>
    <i class="z-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
        <path
          d="M13.6897 0.275968C13.2899 -0.105024 12.6568 -0.089621 12.2759 0.310348C11.8949 0.71033 11.9104 1.34342 12.3103 1.72441L20.6455 9.66535H1C0.44772 9.66535 0 10.1132 0 10.6655C0 11.2179 0.44772 11.6657 1 11.6657H20.6456L12.3103 19.6068C11.9104 19.9878 11.8949 20.621 12.2759 21.021C12.6568 21.4209 13.2899 21.4364 13.6897 21.0554L23.5816 11.6313C23.8068 11.4168 23.9401 11.143 23.9815 10.8585C23.9936 10.7961 24 10.7316 24 10.6655C24 10.5995 23.9936 10.5349 23.9813 10.4723C23.94 10.188 23.8067 9.91447 23.5816 9.70003L13.6897 0.275968Z"
          fill="#115C61"
        />
      </svg>
    </i>
  </a>
}
<div class="flex gap-4 md:gap-6 mb-8">
  @for (tab of tabs(); track tab.id) {
    <div
      class="tab flex items-center justify-center p-3 rounded-lg border border-solid flex-1 h-[3.5rem] md:h-[3.8rem] cursor-pointer"
      [class.selected]="tab.id === selectedTabId"
      (click)="onSelectTab(tab.route)"
    >
      <span class="text-[#003555] text-[1rem]">{{ tab.title | translate }}</span>
    </div>
  }
</div>

<router-outlet></router-outlet>
